<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<form *ngIf="!isLoading" class="pcard" (ngSubmit)="saveChanges()">
  <h2><i class="fa-solid fa-user"></i> Basic Information</h2>

  <div class="photo-row">
    <div class="photo-wrap">
      <img [src]="photoSrc" (error)="onImgError($event)" class="photo" alt="Profile photo" />
      <label for="profileImageInput" class="photo-btn" title="Change photo">
        <i class="fa-solid fa-camera"></i>
      </label>
      <input type="file" id="profileImageInput" accept="image/*" (change)="onImageSelected($event)" hidden />
    </div>
    <div class="photo-text">
      <b>Profile Photo</b>
      <small>JPG or PNG, up to 2MB.</small>
    </div>
  </div>

  <div class="grid-2">
    <div class="fld" *ngFor="let key of fieldKeys()">
      <label [for]="key">{{ formatLabel(key) }}</label>
      <input type="text" [id]="key" [(ngModel)]="user[key]" [name]="key" autocomplete="off" />
    </div>

    <div class="fld">
      <label for="gender">Gender</label>
      <input type="text" id="gender" [(ngModel)]="gender" name="gender" autocomplete="off" />
    </div>
    <div class="fld">
      <label for="DOB">Date of Birth</label>
      <input type="date" id="DOB" [(ngModel)]="DOB" name="DOB" />
    </div>
  </div>

  <div class="actions">
    <button type="submit" class="btn-pink" [disabled]="saving">
      <i class="fa-solid fa-floppy-disk"></i> {{ saving ? 'Saving...' : 'Save Changes' }}
    </button>
    <span class="note" *ngIf="saveMsg" [class.ok]="saveOk" [class.bad]="!saveOk">{{ saveMsg }}</span>
  </div>
</form>
